<template>
    <div class="module-box">
        <template v-if="$route.name === 'haiken'">
            <!-- 国有土地承包经营权 -->
            <land-contract
                v-if="
                    moduleId === 8 ||
                        (moduleId === null && templateCode === '1001')
                "
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
            <!-- 国有资产 -->
            <collective-management
                v-if="
                    moduleId === 9 ||
                        (moduleId === null && templateCode === '1002')
                "
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
        </template>
        <template v-else>
            <!-- 土地承包经营权 -->
            <land-contract
                v-if="moduleId === 1 || moduleId === 999"
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
            <!-- 集体资源性资产 -->
            <rural-collective-equity
                v-if="moduleId === 2 || moduleId === 12"
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
            <!-- 集体经营性资产 -->
            <collective-management
                v-if="
                    moduleId === 3 ||
                        (moduleId === null && templateCode === '1002')
                "
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
            <!-- 林权 -->
            <wood-land-rights
                v-if="
                    moduleId === 4 ||
                        (moduleId === null && templateCode === '1004')
                "
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
            <!-- 农村宅基地和住房 -->
            <rural-homesteads-and-housing
                v-if="
                    moduleId === 5 ||
                        (moduleId === null && templateCode === '1003')
                "
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
            <!-- 农村集体资产股权 -->
            <collective-resources
                v-if="
                    moduleId === 6 ||
                        (moduleId === null && templateCode === '1006')
                "
                :moduleName="moduleName"
                :transferVariety="transferVariety"
                :tradeSum="tradeSum"
            />
            <!-- 农业数据 -->
            <agriculture-data
                v-if="moduleId === 10011"
                :moduleName="moduleName"
            />
            <!-- 高标农田 -->
            <farmland-data
                v-if="moduleId === 10012"
                :moduleName="moduleName"
            />
        </template>
        <!-- 金融贷款 -->
        <financial-loans
            v-if="moduleId === 10007 || moduleId === 7"
            :moduleName="moduleName"
            :tradeSum="tradeSum"
        />
        <!-- 挂牌项目 -->
        <listing-items v-if="moduleId === 10008" :moduleName="moduleName" />
        <!-- 竞拍项目 -->
        <auction-item v-if="moduleId === 10009" :moduleName="moduleName" />
        <!-- 成交公告 -->
        <transaction-record
            v-if="moduleId === 10010"
            :moduleName="moduleName"
        />
    </div>
</template>

<script>
import ListingItems from './ListingItems'
import AuctionItem from './AuctionItem'
import CollectiveResources from './CollectiveResources'
import CollectiveManagement from './CollectiveManagement'
import RuralCollectiveEquity from './RuralCollectiveEquity'
import RuralHomesteadsAndHousing from './RuralHomesteadsAndHousing'
import WoodLandRights from './WoodLandRights'
import LandContract from './LandContract'
import TransactionRecord from './TransactionRecord'
import FinancialLoans from './FinancialLoans'
import AgricultureData from './AgricultureData'
import FarmlandData from './FarmlandData'
/**
 * 海垦大屏交易品种：
 * 国有土地承包经营权
 * 国有资产
 * 金融贷款
 * 挂牌项目
 * 竞拍项目
 * 成交公告
 */

/**
 * 通用大屏交易品种：
 * 土地承包经营权
 * 集体资源性资产
 * 集体经营性资产
 * 林权
 * 农村宅基地和住房
 * 农村集体资产股权
 * 金融贷款
 * 挂牌项目
 * 竞拍项目
 * 成交公告
 * 农业数据
 */
export default {
    props: {
        tradeSum: {
            type: Object,
            default: () => {}
        },
        moduleId: {
            type: Number,
            default: 0
        },
        templateCode: {
            type: String,
            default: ''
        },
        moduleName: {
            type: String,
            default: ''
        },
        transferVariety: {
            type: String,
            default: ''
        }
    },
    components: {
        ListingItems, // 挂牌项目
        AuctionItem, // 竞拍项目
        CollectiveResources, // 农村集体资产股权
        CollectiveManagement, // 集体经营性资产 || 国有资产
        LandContract, // 土地承包经营权 || 国有土地承包经营权
        RuralCollectiveEquity, // 集体资源性资产
        RuralHomesteadsAndHousing, // 农村宅基地和住房
        WoodLandRights, // 林权
        TransactionRecord, // 成交公告
        FinancialLoans, // 金融贷款
        AgricultureData, // 农业数据
        FarmlandData // 高标农田数据
    }
}
</script>
<style lang="scss" scoped>
.module-box {
    width: 620px !important;
    height: 319px;
    padding-top: 1px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/solid_box.png');
    box-sizing: border-box;
    position: relative;
}
</style>
